import { render, staticRenderFns } from "./PostBlock.vue?vue&type=template&id=7967cbda&scoped=true&"
import script from "./PostBlock.vue?vue&type=script&lang=js&"
export * from "./PostBlock.vue?vue&type=script&lang=js&"
import style0 from "./PostBlock.vue?vue&type=style&index=0&id=7967cbda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7967cbda",
  null
  
)

export default component.exports